import { ChangeEvent, useCallback } from 'react'
import _ from 'lodash'
import L3Boolean from '../l3/L3Boolean'
import { submitStatusUpdates } from '../../../redux/submitStatusUpdates'
import { useConcept, useConceptActivation } from '../../../redux/selectConcept'
import { useConceptStatus } from '../../../redux/selectConceptStatus2'
import { useFormDispatch } from '../../../redux/formStoreHooks'
import { ConceptStatusValueType, ConceptValueDataType } from '@fusion-advantage/backcompat'
import { useConceptValidator } from './useConceptValidator'

interface L4BooleanProps {
	xpath: string
	cid?: string
	subconceptCid?: string
	showLabel?: boolean
}

export const L4Boolean = ({xpath, cid, subconceptCid, showLabel = true}: L4BooleanProps) => {
	const { concept, errorNode } = useConceptValidator({
		tagName: 'L4Boolean',
		cid,
		requireConcept: true,
		allowDataTypes: [
			ConceptValueDataType.Check,
			ConceptValueDataType.Checks,
			ConceptValueDataType.Radios,
		],
	})
	const subconcept = useConcept(subconceptCid)
	const conceptStatus = useConceptStatus(cid)
	const activation = useConceptActivation(cid)
	const dispatch = useFormDispatch()
	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		const value = e.target.checked
		const conceptValues = [{
			cid: cid!,
			subconceptCid,
			value,
			valueType: ConceptStatusValueType.Chosen,
		}]
		dispatch(submitStatusUpdates(conceptValues))
	}, [concept, cid, subconceptCid, dispatch])
	if(errorNode) {
		return errorNode
	}
	return (
		<L3Boolean
			xpath={xpath}
			concept={concept!}
			subconcept={subconcept}
			conceptStatus={conceptStatus}
			activation={activation}
			showLabel={showLabel}
			onChange={handleChange}
		/>
	)
}

export default L4Boolean
